// import { useEffect, useRef } from "react";
// import { shallowEqual, useDispatch, useSelector } from "react-redux";
// import {
//   fetchChatList,
//   fetchMessagesForRoom,
//   subscribeToChatList,
//   subscribeToMessagesForRoom,
// } from "./ChatThunk";
// import * as chatV2 from "../../../modules/chat/redux/ChatSlice.v2";
// import { RootState } from "src/setup/redux/store";
// import { useTranslation } from "react-i18next";
// import { toast } from "react-toastify";
// import { Room } from "src/app/models/Chat.v2";

// const chatTypes: ("allChat" | "myChat")[] = ["allChat", "myChat"];

// const ChatListInitializer = () => {
//   const { t } = useTranslation();
//   const audioRef = useRef<HTMLAudioElement>(
//     typeof Audio !== "undefined"
//       ? new Audio("/media/misc/audio/notification.mp3")
//       : null
//   );
//   const dispatch = useDispatch();
//   const { activeTab } = useSelector(
//     (state: RootState) => state.ChatV2,
//     shallowEqual
//   );

//   const {
//     collaborationOrder,
//     collaborationsById,
//     selectedCollaborationId,
//     selectedRoomId,
//   } = useSelector(
//     (state: RootState) =>
//       state.ChatV2[activeTab] ?? {
//         collaborationOrder: [],
//         collaborationsById: {},
//         hasMore: false,
//         isLoading: false,
//         selectedCollaborationId: null,
//         selectedRoomId: null,
//       },
//     shallowEqual
//   );
//   const selectedRoom: Room =
//     collaborationsById[selectedCollaborationId]?.roomsModel?.find(
//       (item) => item?.id === selectedRoomId
//     ) ?? collaborationsById[selectedCollaborationId]?.roomsModel?.[0];

//   const messages = useSelector(
//     (state: RootState) =>
//       state.ChatV2.messagesByRoom[
//         `${selectedCollaborationId}_${selectedRoomId}`
//       ]?.messages ?? []
//   );

//   const messageUnsubRef = useRef<() => void>();
//   const lastToastMapRef = useRef<Record<string, number>>({});

//   // Subscribe to chat list once
//   useEffect(() => {
//     const unsubscribes: (() => void)[] = [];

//     chatTypes.forEach((type) => {
//       dispatch(fetchChatList({ chatType: type, lastInteractionAt: null }));

//       const unsubscribe = subscribeToChatList(type, (collab) => {
//         dispatch(chatV2.updateCollaboration({ chatType: type, data: collab }));
//         const collabId = collab.id;
//         const lastInteractionAt = collab.lastInteractionAt?.seconds ?? 0;

//         const lastShown = lastToastMapRef.current[collabId];
//         if (lastShown === lastInteractionAt) return;

//         lastToastMapRef.current[collabId] = lastInteractionAt;

//         const profile =
//           collab?.profileName ??
//           collab?.userSearchKeys?.[collab?.lastInteractionChannel] ??
//           "";
//         const msg = collab?.lastInteractionMessage ?? "";

//         if (collab?.lastInteractionDestination === "inbound") {
//           toast.info(`${t("Notif.Info.Message")} ${profile} : ${msg}`);
//           audioRef.current?.play().catch(() => {});
//         }
//       });

//       unsubscribes.push(unsubscribe);
//     });

//     return () => {
//       unsubscribes.forEach((unsub) => unsub());
//     };
//   }, [dispatch]);

//   // Fetch and subscribe to messages for selected room
//   useEffect(() => {
//     if (!selectedCollaborationId || !selectedRoomId) return;

//     const alreadyFetched = Array.isArray(messages) && messages.length > 0;

//     if (!alreadyFetched) {
//       dispatch(
//         fetchMessagesForRoom({
//           collaborationId: selectedCollaborationId,
//           roomId: selectedRoomId,
//           conversationId: selectedRoom?.conversationId
//         })
//       );
//     }

//     // Cancel previous subscription
//     if (messageUnsubRef.current) {
//       messageUnsubRef.current(); // Unsubscribe Firestore listener sebelumnya
//     }

//     const unsub = subscribeToMessagesForRoom(
//       selectedCollaborationId,
//       selectedRoomId,
//       selectedRoom?.conversationId,
//       (message, type) => {
//         if (type === "added") {
//           dispatch(
//             chatV2.addNewMessage({
//               collaborationId: selectedCollaborationId,
//               roomId: selectedRoomId,
//               message,
//             })
//           );
//         } else if (type === "modified") {
//           dispatch(
//             chatV2.updateMessage({
//               collaborationId: selectedCollaborationId,
//               roomId: selectedRoomId,
//               message,
//             })
//           );
//         }
//       }
//     );

//     messageUnsubRef.current = unsub;

//     return () => {
//       if (messageUnsubRef.current) {
//         messageUnsubRef.current();
//         messageUnsubRef.current = undefined;
//       }
//     };
//   }, [selectedCollaborationId, selectedRoomId, dispatch]);

//   return null;
// };

// export default ChatListInitializer;

import { useChatListSubscriber } from "./CollaborationSubscriber";
import { useRoomMessagesSubscriber } from "./MessageSubscriber";
import { ensureChatReadAuditConsole, auditChatRead } from "../utils/firestoreReadAudit";
import { useEffect } from "react";

const ChatListInitializer = () => {
  useEffect(() => {
    ensureChatReadAuditConsole();
    auditChatRead({
      event: "chat_initializer",
      source: "private_routes_mount",
      estimatedReads: 0,
    });

    return () => {
      auditChatRead({
        event: "chat_initializer",
        source: "private_routes_unmount",
        estimatedReads: 0,
      });
    };
  }, []);

  useChatListSubscriber();
  useRoomMessagesSubscriber();

  return null;
};

export default ChatListInitializer;
